module.exports = __webpack_public_path__ + "img/drop3.3277049a.png";